module.exports = __webpack_public_path__ + "static/media/Animelab.f341d5dc.svg";